export const CRYPTO_TYPES = {
    usdc: 0,
};
